export const tickSizesByMarket = {
  BTC: [1, 2, 5, 10, 100, 1000],
  ETH: [0.1, 0.2, 0.5, 1, 10, 100],
};
